<template>
  <a
    v-if="downloadUrl"
    :href="downloadUrl"
    class="brochure-tile-fi"
    download
    @click="handleDownload"
  >
    <div class="brochure-tile-fi__image-container">
      <cloud-image-fi
        v-if="thumbnailUrl"
        class="brochure-tile-fi__image"
        :src="thumbnailUrl"
        :alt="title"
        params="func=fit&bg_img_fit=1&bg_opacity=0.7&bg_colourise=black&bg_blur=100&fit_enlarge=1"
      />
    </div>
    <div class="brochure-tile-fi__content">
      <icon-fi
        class="brochure-tile-fi__file-download-icon"
        icon="download"
      />
      <div
        v-if="title"
        class="brochure-tile-fi__headline"
      >
        {{ title }}
      </div>
      <p
        v-if="previewText"
        class="brochure-tile-fi__preview-text"
      >
        {{ previewText }}
      </p>
    </div>
  </a>
</template>

<script>
import { IconFi } from 'atoms';
import CloudImageFi from 'components/atoms/cloud-image-fi/CloudImageFi';

import eventHubMixin from '@/mixins/eventHubMixin.vue';
export default {
  name: 'BrochureTilesFi',
  components: {
    CloudImageFi,
    IconFi,
  },
  mixins: [eventHubMixin],
  props: {
    title: {
      type: String,
      default: '',
    },
    previewText: {
      type: String,
      default: '',
    },
    downloadUrl: {
      type: String,
      default: '',
    },
    thumbnailUrl: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleDownload() {
      this.sendEvent('custom', {}, 'download', {
        link: this.downloadUrl,
        name: this.title,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './brochure-tile-fi.scss';
</style>
